// -----------------------------------------------------------------------------
// Pure classifiers for axios errors — extracted so they can be unit-tested
// without pulling the whole auth context (which imports @/lib/api and hence
// depends on webpack aliases that jest does not resolve out of the box).
// -----------------------------------------------------------------------------

// Statuses that we retry ONCE and never treat as auth failure.
export const TRANSIENT_STATUS = new Set([500, 502, 503, 504]);

// A response with no status is a network / abort / CORS-preflight failure.
// Treat those as transient (retry once, do NOT sign the user out).
export function isTransientAxiosError(err) {
  const status = err?.response?.status;
  if (status == null) return true; // network-level
  return TRANSIENT_STATUS.has(status);
}

export function isAuthFailureStatus(err) {
  const status = err?.response?.status;
  return status === 401 || status === 403;
}

export const RETRY_DELAY_MS = 400;
